import { STORE_MODULE_NAME } from "./searchStoreModule";

export default function useSearch() {

  const fetchByContentTypeIdDataUrl = `${STORE_MODULE_NAME}/get_by_content_type_id`
  const fetchByModelPathDataUrl = `${STORE_MODULE_NAME}/get_by_model_path`

  return {
    fetchByContentTypeIdDataUrl,
    fetchByModelPathDataUrl
  }
}
